import { createPromiseAction } from '@adobe/redux-saga-promise';

// Send OTP Actions
export const sendOtp = createPromiseAction('verification/sendOtp');

// Verify OTP Actions
export const verifyOtp = createPromiseAction('verification/verifyOtp');
